/**
 * The React binding for the locale store.
 *
 * Its own file so `format.ts` and `index.tsx` can both read the active locale without
 * importing each other, and so `locale.ts` stays free of React.
 */

import { useSyncExternalStore } from 'react'

import { getLocale, subscribeToLocale } from './locale'
import type { Locale } from './shared'

/** Re-renders the component on every locale change. Works with or without `LocaleProvider`. */
export const useActiveLocale = (): Locale =>
  useSyncExternalStore(subscribeToLocale, getLocale, getLocale)
